export default "__VITE_ASSET__DeBNKOd$__"